import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PdfPreviewModalData {
  pdfSrc: string;
  fileName: string;
}

@Component({
    selector: 'app-pdf-preview-modal',
    templateUrl: './pdf-preview-modal.component.html',
    styleUrls: ['./pdf-preview-modal.component.css'],
    standalone: false
})
export class PdfPreviewModalComponent {
  pdfSrc: string;
  fileName: string;
  page: number = 1;
  totalPages: number = 0;
  zoom: number = 1.0;
  showZoom: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PdfPreviewModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PdfPreviewModalData
  ) {
    this.pdfSrc = data.pdfSrc;
    this.fileName = data.fileName;
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  onLoadComplete(pdf: { numPages: number }): void {
    this.totalPages = pdf.numPages;
  }

  previousPage(): void {
    if (this.page > 1) {
      this.page--;
    }
  }

  nextPage(): void {
    if (this.page < this.totalPages) {
      this.page++;
    }
  }

  zoomIn(): void {
    if (this.zoom < 2.0) {
      this.zoom += 0.25;
    }
  }

  zoomOut(): void {
    if (this.zoom > 0.5) {
      this.zoom -= 0.25;
    }
  }

  resetZoom(): void {
    this.zoom = 1.0;
  }

  downloadPdf(): void {
    const link = document.createElement('a');
    link.href = this.pdfSrc;
    link.download = this.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

